import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=738e7db7&"
import script from "./ModalTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports